import { useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { I18_NEXT_LNG, LANGUAGE, OIDC_NEXT_URL } from '../store/types';
import { updateEventTrackingCount } from '../_db/api.service';
import { LocalStorage, setStorage } from '../utils/storage';

const LANG_CODE = {
  [LANGUAGE.cn]: 'cn',
  [LANGUAGE.tw]: 'tw',
  [LANGUAGE.es]: 'en',
  [LANGUAGE.vn]: 'vn',
  [LANGUAGE.jp]: 'en'
}
/* =========================================================================== */
export function useRouter() {
  const navigator = useNavigate();

  const width = window.innerWidth < 800 ? window.innerWidth : 800;
  const height = window.innerHeight < 700 ? window.innerHeight : 700;

  const top = (window.innerHeight - height) / 2;
  const left = (window.innerWidth - width) / 2;


  const router = useMemo(
    () => ({
      previous: () => window.history.back(),
      back: () => navigator(-1),
      forward: () => navigator(1),
      reload: () => window.location.reload(),
      push: (href, state) => navigator(href, { state }),
      replace: (href) => navigator(href, { replace: true }),
      pushState: (state, url) => window.history.pushState(state, '', url),
      replaceState: (state, url) => window.history.replaceState(state, '', url),

      /*
      * 內容頁跳轉
      * record: 當前Click Item數據源
      * state: { children: [catalogsItem, contentItem] }; page一級欄目 catalogsItem二級欄目Ojb contentItem三級欄目Obj
      */ 
      onCatalogContentLink: async (record, state) => {
        const { catalogId, contentId, contentType } = record || {};
        const { page, children } = state || {};
        const [catalog, content] = children || [];
        // console.log(`/honhai/details/${page || new Date().getTime()}/${catalog?.contentCode || new Date()}/${content?.contentCode || new Date()}/${catalogId}/${contentType}/${contentId}`)
        navigator(
          `/honhai/details/${catalog?.contentCode || new Date()}/${content?.contentCode || new Date()}/${catalogId}/${contentType}/${contentId}/${page}`, {
            state
          })
      },

      /*
      * 內容頁跳轉-分頁
      * record: 當前Click Item數據源
      * state: { children: [catalogsItem, contentItem] }; page一級欄目 catalogsItem二級欄目Ojb contentItem三級欄目Obj
      */ 
      onCatalogContentPageLink: async (record, state) => {
        const { catalogId, contentId, contentType } = record || {};
        const { level, payload } = state || {};
        const [ level1, level2 ] = level || {};

        // console.log(`/honhai/content/details/${level1?.contentCode || new Date()}/${level2?.contentCode || new Date()}?catalogId=${catalogId}&contentType=${contentId}&${contentType}&ruleTag=${pagiantion?.ruleTag}&page=${pagiantion?.page}&page=${pagiantion?.rowsPerPage}`)
        navigator(
          `/honhai/content/details/${level1?.contentCode || new Date()}/${level2?.contentCode || new Date()}?catalogId=${catalogId}&contentId=${contentId}&contentType=${contentType}&ruleTag=${payload?.ruleTag}&page=${payload?.page}&rowsPerPage=${payload?.rowsPerPage}`, 
          { state: { ...payload } }
        )
      },


      // 勞安內容頁跳轉
      onLauanContentLink: async (record, state) => {
        const { catalogId, contentId, contentType } = record || {};
        const { children } = state || {};
        const [catalog, content] = children || [];
        navigator(
          `/honhai/lauan/details/${catalog?.contentCode || new Date()}/${content?.contentCode || new Date()}/${catalogId}/${contentType}/${contentId}`, {
            state
          });
      },

      // 相信單點登錄
      onIcivetAuthorize: (url) => {
        const lang = LocalStorage.get(I18_NEXT_LNG) || LANGUAGE.tw;
        if(url) { setStorage(OIDC_NEXT_URL, url) };
        window.open(`${process.env.REACT_APP_ICIVET_AUTH_URL}&lang=${LANG_CODE[lang]}&state=${url || 'view_my_performance'}}`, '_self');
      },
      onCloseIcivetOpener: () => {
      },

      // 相信單點登錄
      onSessionLogin: (url = '') => {
        navigator(Boolean(url) ? `/session/login?redirect=${url}` : `/session/login`)
      },
    }),
    [navigator]
  );

  return router;
};



/*
* 获取返回页面时的来源路径
*/ 
export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};


export function useEventTracking() {
  const eventTracking = useMemo(
    () => ({
      onContentEventTracking: async (payload) => {
        const res = await updateEventTrackingCount(payload);
      },
    }),
    []
  );

  return eventTracking;
};
